import React from "react";

import styles from "./ResponsiveLabel.module.scss";

/**
 * Renders one of two labels depending on viewport width — full label
 * on wide screens, short label below the mobile breakpoint. Both are
 * always in the DOM (one is hidden via CSS), so translators see both
 * strings during gettext extraction.
 */
type ResponsiveLabelProps = {
    full: React.ReactNode;
    short: React.ReactNode;
};

export const ResponsiveLabel = ({ full, short }: ResponsiveLabelProps) => (
    <>
        <span className={styles.fullLabel}>{full}</span>
        <span className={styles.shortLabel}>{short}</span>
    </>
);
